import styled from 'styled-components'

type StyledProps = {
  isEmpty?: boolean;
}

const StyledCheckoutView = styled.div<StyledProps>`
  height: fit-content;

  .checkout-sizer {
    display: grid;
    grid-gap: 40px;
    user-select: none;
  }

  .cart-area {
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.gray[100]};
    border-radius: 6px;
  }

  .checkout-summary-container {
    .checkout-summary-heading {
      font-weight: 700;
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[700]};
      padding-bottom: 10px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};
    }

    ul {
      margin: 20px 0;
      padding: 0;
      list-style-type: none;
      display: grid;
      grid-gap: 10px;

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .checkout-summary-item-label {
          font-weight: 600;
          color: ${({ theme }) => theme.colors.gray[700]};
        }

        .checkout-summary-item-amount {
          color: ${({ theme }) => theme.colors.gray[600]};
        }
      }
    }

    ${({ isEmpty }) =>
    isEmpty &&
      `
      .promo-input {
        pointer-events: none;
        opacity: 0.8;
      }
    `}

    .purchase-btn {
      height: 45px;
      display: flex;
      width: 100%;
      text-align: center;
      justify-content: center;
      margin-top: 20px;
      align-items: center;
      border: none;
      transition: background-color 0.2s, color 0.2s;
      border-radius: 6px;
      padding: 0 10px;
      font-weight: 600;
      user-select: none;
      background-color: ${({ theme }) => theme.colors.green[500]};
      color: ${({ theme }) => theme.colors.background};

      span {
        position: relative;
        top: 1px;
      }

      svg {
        height: 18px;
        margin-right: 8px;
      }

      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.colors.green[600]};
      }

      &:disabled {
        background-color: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[500]};

        &:hover {
          cursor: not-allowed;
          background-color: ${({ theme }) => theme.colors.gray[100]};
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    height: calc(100vh - 4rem - 50px - 40px);
    display: grid;
    align-items: center;

    .cart-area {
      height: 340px;
      overflow-y: auto;
    }

    .checkout-sizer {
      grid-template-columns: minmax(0, 1fr) 385px;
    }

    .checkout-summary-container {
      display: grid;
      align-content: space-between;
    }
  }
`

export default StyledCheckoutView
